{
    "Omclient": "Cliente Omnicanal:",
    "OmclientAgentValidation": "Um cliente Omnichannel requer um agente ACD de endpoint",
    "DeviceHint": "Selecione o endpoint de supervisores para permitir os controles de chamada baseados em navegador integrados",
    "OmnichannelAgent": "Agente Omnicanal:",
    "NoneSelected": "[Nenhum selecionado]",
    "NoAssociatedDevice": "[Nenhum dispositivo associado]",
    "NoAssociatedAgent": "[Sem Agente ACD Associado]",
    "ExtensionEndpoint_PermissionsNote": "Defina as permissões de nível de acesso do usuário.",
    "ExtensionEndpoint_CmEnvironment": "AGC:",
    "ExtensionEndpoint_TelServer": "Servidor de telefonia:",
    "ExtensionEndpoint_Partition": "Partição:",
    "ExtensionEndpoint_Device": "Dispositivo:",
    "ExtensionEndpoint_AndOrAgent": "E\/ou Agente:",
    "NAME": "ExtensionEndpoint",
    "ExtensionEndpoint_Validation_Professional_Device": "Um utilizador Profissional tem de ter um ponto final de dispositivo definido",
    "ExtensionEndpoint_Validation_Professional_Device_MST": "Um utilizador CXA Unused tem de ter um terminal de dispositivo definido",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent": "Um agente do centro de atendimento tem de ter um terminal de agente definido",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent_MST": "Um utilizador do CXA Premium tem de ter um ponto final de agente definido"
}